import { transformTableColumnsFromServerFormat } from '../helpers.js'
import FilesGroup from '../File/FilesGroup.js'
import { loadObjectFiles, loadPreloadedFiles } from '../File/FileUtils.js'

export const objectCardDocuments = {
  data: () => {
    return {
      propertyKey: 'document',
      filesGroupKey: null,
      filesGroupName: null,
      categoryKey: null,
      documentType: null,
      contentType: null,
      documentFilter: null,
      treeView: false,
      listView: false,
      readonly: true,
      addOnly: false,
      sourceConfig: null,
      highlightErrors: false,
      calculateHash: false,

      isReady: false,
      objectId: null,
      category: null
    }
  },
  computed: {
    hasSelected: function () {
      return this.category && this.category.selectedFiles.length
    },
    enabledOnAddAny: function () {
      let enabled
      if (this.readonly) {
        enabled = false
      } else if (this.hasSelected) {
        if (this.category.selectedFiles.length === 1) {
          enabled = this.category.selectedFiles[0].type === 'folder'
        } else {
          enabled = false
        }
      } else {
        enabled = true
      }
      return enabled
    },
    disabledOnAddFolder: function () {
      const enabled = this.treeView ? this.enabledOnAddAny : false
      return !enabled
    },
    disabledOnAddFile: function () {
      const enabled = this.treeView ? this.enabledOnAddAny : true
      return !enabled
    },
    attachFn: function () {
      if (this.object._card) {
        const cardParams = this.object._card.cardParams
        return (cardParams && cardParams.attachFn) || null
      }
      return null
    },
    showOnAttachFiles: function () {
      return this.attachFn
    },
    disabledOnAttachFiles: function () {
      return !(this.hasSelected && this.category.selectedFiles.find(file => file.type === 'folder') == null)
    }
  },
  watch: {
    isReady: {
      handler: function (value) {
        this.$emit('ready', value)
      },
      immediate: true
    }
  },
  methods: {
    onObjectChanged: function (object) {
      this.isReady = false
      if (object) {
        const propertyKey = this.propertyKey
        const filesGroupKey = this.filesGroupKey || propertyKey
        let filesGroup = object._filesGroups.getFilesGroup(filesGroupKey)
        if (!filesGroup) {
          filesGroup = this.createObjectFilesGroup(object, propertyKey, filesGroupKey)
          object._filesGroups.addFilesGroup(filesGroup) // TODO использовать Promise
        }
        this.category = filesGroup
        this.objectId = object.id
        this.isReady = true
      } else {
        this.category = null
        this.objectId = null
      }
    },
    createObjectFilesGroup: function (object, propertyKey, filesGroupKey) {
      let sourceConfig = this.sourceConfig
      if (!sourceConfig) {
        sourceConfig = {
          objectId: object.id,
          uploadURL: '/service/delta/document/upload',
          removeDelayed: true
        }
        if (this.treeView) {
          sourceConfig.removeTreeNode = true
        } else {
          sourceConfig.removeRelationships = true
        }
      } else if (sourceConfig.objectId === undefined) {
        sourceConfig.objectId = object.id
      }

      let documents
      if (this.objectValueSource) {
        documents = object[propertyKey]
        documents = documents && Array.isArray(documents) ? documents : null
      } else {
        try {
          if (sourceConfig.objectId != null && sourceConfig.objectId !== -1) {
            documents = loadObjectFiles({
              objectId: sourceConfig.objectId,
              propertyKey: propertyKey,
              filter: this.documentFilter
            })
          } else if (sourceConfig.preloadFormId) {
            documents = loadPreloadedFiles(sourceConfig.preloadFormId)
          }
        } catch (ignored) {
        }
      }

      const foldersPropertyKey = propertyKey + 'Folders'
      const foldersRaw = object[foldersPropertyKey]
      const folders = transformTableColumnsFromServerFormat(foldersRaw) || []

      return new FilesGroup({
        key: filesGroupKey,
        title: this.filesGroupName,
        property: propertyKey,
        categoryKey: this.categoryKey,
        documentType: this.documentType,
        readonly: this.readonly,
        documents,
        folders: this.treeView ? folders : null,
        sourceConfig
      })
    },

    /**
     * Действия над файлами
     */
    onAddFolder: function () {
      return this.$refs.filesField.onAddFolder()
    },
    onAddFile: function () {
      this.$refs.filesField.onAddFile()
    },
    onDownloadFiles: function () {
      this.$refs.filesField.onDownloadFiles()
    },
    onDownloadFilesInArchive: function () {
      this.$refs.filesField.onDownloadFilesInArchive()
    },
    onDownloadAllFiles: function () {
      const objectId = this.objectId
      const relationshipType = this.propertyKey
      this.$refs.filesField.onDownloadFile({ url: 'service/fileobj/loadall/' + objectId + '?rel=' + relationshipType })
    },
    onAttachFiles: function () {
      const files = this.category.selectedFiles.slice()
      this.attachFn(files)
      // this.$emit('attach', files)
      setTimeout(() => this.category.clearSelection(), 500) // tooltip
    }
  }
}
